module.exports = __webpack_public_path__ + "static/media/cok.c00540ea.svg";